import { useEffect } from 'react';

export const useCookiesCopying = () => {
  useEffect(() => {
    const CART_INFO = 'cartInfo';
    const SHOPPING_LIST = 'shoppingList';
    const DOMAIN = 'lemanapro.ru';

    const parseCookie = (str: string) =>
      str
        .split(';')
        .map(v => v.split('='))
        .reduce((acc: { [key: string]: string }, v) => {
          acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(v[1]?.trim());
          return acc;
        }, {});

    const serializeCookie = (name: string, val: string) =>
      `${encodeURIComponent(name)}=${encodeURIComponent(val)}; Path=/; Domain=.${DOMAIN}; Expires=${new Date(
        Date.now() + 1000 * 60 * 60 * 24 * 365
      )}`;

    const startIFrame = () => {
      if (!window.location.hostname.endsWith(DOMAIN)) return;
      const lmIFrame = document.createElement('iframe');
      lmIFrame.setAttribute('src', 'https://leroymerlin.ru/5sgdmfD2wXGnNsQMcywx.html');

      lmIFrame.style.width = '0px';
      lmIFrame.style.height = '0px';
      lmIFrame.style.position = 'absolute';
      lmIFrame.onload = onOldSiteLoad;
      document.body.appendChild(lmIFrame);

      function onOldSiteLoad() {
        window.onmessage = (e: MessageEvent) => {
          if (typeof e.data === 'string' && e.data.startsWith('LMCookieTransfer')) {
            const currentCookie = document.cookie;
            if (!currentCookie.includes(CART_INFO) && !currentCookie.includes('loadLmCookie')) {
              const objCookie = parseCookie(e.data.replace('LMCookieTransfer:', ''));
              if (objCookie[CART_INFO]) {
                document.cookie = serializeCookie(CART_INFO, objCookie[CART_INFO]);
                document.body.dispatchEvent(
                  new CustomEvent('basket:update', {
                    detail: objCookie[CART_INFO].split(';')
                      .map(v => v.split('='))
                      .map(([code, quantity]) => ({
                        code,
                        quantity: parseFloat(quantity),
                      })),
                  })
                );
              }
              if (objCookie[SHOPPING_LIST]) {
                document.cookie = serializeCookie(SHOPPING_LIST, objCookie[SHOPPING_LIST]);
              }
              document.cookie = serializeCookie('loadLmCookie', 'true');
            }
            lmIFrame.remove();
          }
        };
        lmIFrame.contentWindow?.postMessage('pingLMCookie', '*');
      }
    };

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      startIFrame();
    } else {
      document.addEventListener('DOMContentLoaded', startIFrame);
    }
  }, []);
};
